module.exports = __webpack_public_path__ + "img/IE_logo_mark.43cc807b.png";